import React, { useState, useEffect } from "react";
import ticketSingle from "../../assets/png/ticket_single.png";
import { Logout } from "../../fetch/api/login";
import success from "../../assets/png/success.png";
import { Spin, Progress, message as AndMessage, Upload } from "antd";
import { ReactSVG } from "react-svg";
import {
  uploadmedia,
  profilesetting,
  handleLevel,
} from "../../fetch/api/login";

const LogoutModal = ({ toggleModal, setAvatar }) => {
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState(
    JSON.parse(localStorage.getItem("login")).username
  );
  const [imageUrl, setImageUrl] = useState(
    JSON.parse(localStorage.getItem("login")).avatar_small
  );
  const [fileList, setFileList] = useState([]);

  const beforeUpload = (file) => {
    setImageUrl(window.URL.createObjectURL(file));
    setFileList([file]);
    return false;
  };
  const uploadImage = () => {
    return new Promise((resolve, reject) => {
      let uploadForm = new FormData();
      uploadForm.append("image_file[]", fileList[0]);
      uploadForm.append("type", "avatar");
      uploadmedia(uploadForm).then((res) => {
        if (res) {
          const { code, data, message } = res;
          if (code == 200) {
            resolve(data[0]);
          } else {
            reject(message);
          }
        }
      });
    });
  };
  const [levelData, setlevelData] = useState({});
  useEffect(() => {
    handleLevel().then((res) => {
      if (res) {
        setLoading(false);
        const { code, data, message } = res;
        if (code == 200) {
          setlevelData(data);
        } else {
          AndMessage.error({
            content: message,
            maxCount: 1,
          });
        }
      }
    });
  }, []);
  return (
    <div className="fixed z-50 w-full overflow-x-hidden overflow-y-auto md:inset-0 h-[100%] max-h-full bg-[rgba(0, 0, 0, 0.61)] backdrop-blur-[7px] inset-0">
      <div className="relative w-full h-full flex items-center justify-center">
        {/* <!-- Modal content --> */}
        <div className="relative bg-white rounded-[10px] shadow w-[317px] h-[417px] m-auto flex flex-col">
          {/* <!-- Modal header --> */}
          <div className="flex rounded-t-[10px] bg-stadeo-bold-green h-[75px]">
            <div className="pl-[51px] w-[155px] pt-[19px] leading-[14px]">
              <p className="font-monumentextended text-[12px] font-bold text-white">
                LOGIN TO PURCHASE TICKETS
              </p>
            </div>
            <div className="ml-[20px] pt-[17px] relative">
              <img
                className="w-[45px] md:w-[55px] absolute top-[15px] left-[6px] z-10"
                src={ticketSingle}
                alt="Ticket Single"
              />
              <img
                className="w-[45px] md:w-[55px] relative z-20"
                src={ticketSingle}
                alt="Ticket Single"
              />
            </div>

            <button
              type="button"
              className="absolute right-[11px] top-[11px] text-white text-sm"
              onClick={setAvatar}
            >
              <svg
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </button>
          </div>
          {/* <!-- Modal body --> */}
          <div className="w-full flex justify-center flex-1">
            <Spin spinning={loading}>
              <div className="w-full h-full flex flex-col items-center">
                <div className="mt-[20px] relative">
                  <Upload
                    name="avatar"
                    showUploadList={false}
                    maxCount="1"
                    beforeUpload={beforeUpload}
                    className="logoutmodalUpload"
                  >
                    <img
                      className="w-[98px] h-[98px] rounded-[100%]"
                      src={imageUrl}
                    />
                  </Upload>
                  <div className=" absolute top-[-10px] left-[-10px] pointer-events-none">
                    <Progress
                      strokeLinecap="round"
                      type="dashboard"
                      percent={(levelData.exp / levelData.next_level_exp) * 100}
                      strokeWidth="5"
                      strokeColor="#09B251"
                      size={120}
                      showInfo={false}
                      className="logoutmodalProgress"
                    />
                    <div className="flex items-center justify-center  translate-y-[-24px] bg-[#E7FDF1] rounded-[8px] w-fit m-auto  rounded-tl-[20px] rounded-bl-[20px]">
                      <div className=" flex justify-center items-center w-[25px] h-[25px] rounded-[100%] bg-[#09B251]  border-[1.07px] border-white text-center text-white  z-[2]">
                        <span className="scale-[calc(11_/_12)]">
                          {levelData.level}
                        </span>
                      </div>
                      <div className="bg-[#E7FDF1] rounded-[8px]  h-[25px] text-center  flex justify-center items-center text-[#09B251]  z-[1]">
                        <span className="scale-[calc(10_/_12)]">
                          <span className=" font-bold">{levelData.exp}</span>/
                          <span>{levelData.next_level_exp}</span>
                        </span>
                      </div>
                    </div>
                    <div className="absolute bottom-[0px] translate-y-[0px] left-[50%] translate-x-[-50%]">
                      {levelData.level ? (
                        <ReactSVG
                          className="ReactSVG"
                          width={60}
                          height={12}
                          src={require(`../../assets/svg/nickname/label_${levelData.level}.svg`)}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className=" flex items-center w-[219px] border border-[#BDBDBD] overflow-hidden h-[33px] rounded-[5px] font-semibold  mt-[45px] pl-[5px] pr-[5px]">
                  <div className="flex-1 h-full ">
                    <input
                      maxLength="16"
                      className="outline-0 w-full h-full text-[12px] font-medium placeholder:scale-[calc(6.53_/_12)] placeholder:origin-left"
                      placeholder="Change username"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                  </div>
                  {name.length === 0 ? (
                    <span className="text-[12px] scale-[calc(6.53_/_12)] text-[#BDBDBD]">
                      *required
                    </span>
                  ) : (
                    <div className="flex h-full items-center">
                      <span className="scale-[calc(7.64_/_12)] text-[12px] text-[#C4C4C4]">
                        {name.length}/16
                      </span>
                      <img src={success} alt="" />
                    </div>
                  )}
                </div>
                <Upload
                  name="avatar"
                  showUploadList={false}
                  maxCount="1"
                  beforeUpload={beforeUpload}
                  className="logoutmodalUpload"
                >
                  <div className=" mt-[10px] text-[12px] scale-[calc(8.7_/_12)] text-[#283AC6] underline cursor-pointer">
                    Change profile image
                  </div>
                </Upload>
                <div
                  className={`w-[219px] h-[30px] text-white  flex items-center justify-center rounded-[57px] mt-[15px]  cursor-pointer ${
                    fileList.length > 0 ||
                    JSON.parse(localStorage.getItem("login")).username != name
                      ? "bg-[#09B251]"
                      : "bg-[#BDBDBD]"
                  }`}
                  onClick={async () => {
                    if (
                      fileList.length > 0 ||
                      JSON.parse(localStorage.getItem("login")).username != name
                    ) {
                      setLoading(true);
                      let userInfo = {
                        username: name,
                      };
                      if (fileList.length > 0) {
                        await uploadImage()
                          .then((res) => {
                            userInfo.avatar = res.image;
                          })
                          .catch((error) => {
                            setLoading(false);
                            AndMessage.error({
                              content: error,
                              maxCount: 1,
                            });
                          });
                      }
                      profilesetting(userInfo).then((res) => {
                        if (res) {
                          setLoading(false);
                          const { code, data, message } = res;
                          if (code == 200) {
                            localStorage.setItem("login", JSON.stringify(data));
                            setFileList([]);
                          } else {
                            AndMessage.error({
                              content: message,
                              maxCount: 1,
                            });
                          }
                        }
                      });
                    }
                  }}
                >
                  <span className="scale-[calc(9.16_/_12)] text-[12px] font-semibold">
                    SAVE
                  </span>
                </div>
                <div
                  className="w-[219px] h-[29.34px] text-[#E73232] text-[12px] font-semibold border border-[#E73232] rounded-[57.3099px] flex items-center justify-center mt-[10px] cursor-pointer"
                  onClick={() => {
                    setLoading(true);
                    Logout().then((res) => {
                      const { code } = res;
                      if (code == 200) {
                        localStorage.removeItem("login");
                        window.history.pushState(
                          "",
                          "",
                          window.location.origin
                        );
                        setLoading(false);
                        setAvatar();
                      }
                    });
                  }}
                >
                  <span className="scale-[calc(9.16_/_12)]"> LOGOUT</span>
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
